"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin, Clock, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function UbicacionesYMapa() {
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: locationsRef,
    isVisible: locationsVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const locations = [{
    id: 1,
    name: "LUMIÈRE Polanco",
    address: "Av. Presidente Masaryk 430, Polanco, CDMX",
    phone: "+52 55 6789 1011",
    hours: "Lunes a Sábado: 10am - 8pm",
    lat: 19.4326,
    lng: -99.1332
  }, {
    id: 2,
    name: "LUMIÈRE Santa Fe",
    address: "Centro Santa Fe, Piso 2, Local 245, CDMX",
    phone: "+52 55 6789 1012",
    hours: "Lunes a Domingo: 11am - 9pm",
    lat: 19.3595,
    lng: -99.2619
  }, {
    id: 3,
    name: "LUMIÈRE Insurgentes",
    address: "Av. Insurgentes Sur 1971, Guadalupe Inn, CDMX",
    phone: "+52 55 6789 1013",
    hours: "Lunes a Sábado: 10am - 8pm",
    lat: 19.3614,
    lng: -99.1869
  }];
  return <section id="ubicaciones-y-mapa" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl md:text-5xl tracking-tight mb-4">
            Nuestras Ubicaciones
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Visítanos en cualquiera de nuestras boutiques y descubre la elegancia en persona
          </p>
        </div>

        {}
        <div ref={mapRef} className={`mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${mapVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="relative w-full h-[500px] rounded-lg overflow-hidden shadow-medium group">
            <div className="absolute inset-0 bg-secondary/5 backdrop-blur-[2px] transition-all duration-[var(--duration-medium)] group-hover:bg-transparent">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1548683/img/lumiere_boutique_locations_map.png" alt="Mapa de ubicaciones de LUMIÈRE Boutique" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-[var(--duration-slow)]" />
            </div>
            {locations.map((location, i) => <div key={location.id} data-index={i} className="absolute bg-accent rounded-full size-4 animate-pulse shadow-strong cursor-pointer hover:scale-150 transition-transform duration-[var(--duration-fast)]" style={{
            top: `${40 + i * 15}%`,
            left: `${35 + i * 20}%`
          }} title={location.name} />)}
          </div>
        </div>

        {}
        <div ref={locationsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${locationsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {locations.map((location, i) => <div key={location.id} data-index={i} className="group bg-white rounded-lg shadow-soft border border-transparent p-6 hover:shadow-medium hover:bg-primary-light/50 hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <h3 className="font-display text-2xl mb-4 transition-colors duration-[var(--duration-medium)] group-hover:text-accent">
                {location.name}
              </h3>

              <div className="space-y-3 text-muted-foreground">
                <div className="flex items-start gap-3">
                  <MapPin className="size-5 shrink-0 mt-0.5 text-accent" />
                  <p className="text-sm leading-relaxed">{location.address}</p>
                </div>

                <div className="flex items-center gap-3">
                  <Phone className="size-5 shrink-0 text-accent" />
                  <Link to={`tel:${location.phone.replace(/\s/g, "")}`} className="text-sm hover:text-accent transition-colors duration-[var(--duration-fast)]">
                    {location.phone}
                  </Link>
                </div>

                <div className="overflow-hidden">
                  <div className="flex items-start gap-3 transition-all duration-[var(--duration-medium)] ease-in-out max-h-0 opacity-0 group-hover:max-h-20 group-hover:opacity-100">
                    <Clock className="size-5 shrink-0 mt-0.5 text-accent" />
                    <p className="text-sm leading-relaxed">{location.hours}</p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}